import { Product } from '../model/product';
import { ProductType } from '../model/product-type';

export class ProductUtil {
  public static groupProductsByPlan(products: Product[]): Product[] {
    const planGroups = new Map<
      string,
      { monthly?: Product; annual?: Product; type: ProductType }
    >();

    products.forEach(product => {
      const productType = product.type;
      if (!productType) {
        return;
      }

      const planKey = this.getPlanKeyFromType(productType);
      if (planKey === 'unknown') {
        return;
      }

      const isMonthly = product.name.toLowerCase().includes('monthly');
      const isAnnual = product.name.toLowerCase().includes('annual');

      if (!planGroups.has(planKey)) {
        planGroups.set(planKey, { type: productType });
      }

      const group = planGroups.get(planKey)!;

      if (isMonthly) {
        group.monthly = product;
      } else if (isAnnual) {
        group.annual = product;
      }
    });

    const unifiedProducts: Product[] = [];

    planGroups.forEach((group, planKey) => {
      if (group.monthly || group.annual) {
        unifiedProducts.push({
          apiName: planKey,
          name: this.getDisplayName(planKey),
          type: group.type,
        });
      }
    });

    return unifiedProducts;
  }

  private static getPlanKeyFromType(type: ProductType): string {
    switch (type) {
      case 'PERSONAL':
        return 'my-vital-id-personal';
      case 'FAMILY':
        return 'my-vital-id-family';
      case 'PRODUCT':
        return 'link-product';
      default:
        return 'unknown';
    }
  }

  public static getDisplayName(planKey: string): string {
    switch (planKey) {
      case 'my-vital-id-personal':
        return 'My Vital ID Personal';
      case 'my-vital-id-family':
        return 'My Vital ID Family Plan';
      case 'link-product':
        return 'Link Product';
      default:
        return planKey;
    }
  }

  private static readonly API_NAME_MAP: Record<
    string,
    { monthly: string; annual: string }
  > = {
    'my-vital-id-personal': {
      monthly: 'my-vital-id-personal-use-monthly',
      annual: 'my-vital-id-personal-use-annual',
    },
    'my-vital-id-family': {
      monthly: 'my-vital-id-family-use-monthly',
      annual: 'my-vital-id-family-use-annual',
    },
    'link-product': {
      monthly: 'link-monthly',
      annual: 'link-annual-subscription',
    },
  };

  public static getApiNameForBillingFrequency(
    planKey: string,
    billingFrequency: string
  ): string {
    const mapping = this.API_NAME_MAP[planKey];

    if (!mapping) {
      return planKey;
    }

    return billingFrequency === 'monthly' ? mapping.monthly : mapping.annual;
  }
}
